<script setup>
defineProps({
  color: {
    type: String,
    default: '#00990f',
  },
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-labelledby="box"
    role="presentation"
  >
    <g :fill="color" :stroke="color" stroke-width="1">
      <path
        d="M14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29972 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.7233 1.50198 11.3754 2.18744 12.594 3.406C13.8126 4.62455 14.498 6.2767 14.5 8Z"
      />
    </g>
  </svg>
</template>
